import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        releaseNotes: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'releaseNote.Important changes in Coursy' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="changelog-item" ng-repeat-start="(date, releaseNotes) in vm.releaseNotes">
                <p class="meta">{{ date }}</p>
                <span ng-repeat="releaseNote in releaseNotes">
                    <h3>{{ releaseNote.activeI18n.title }}</h3>
                    <p ng-bind-html="releaseNote.activeI18n.content"></p>
                </span>
            </div>
            <span ng-repeat-end></span>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.uibModalInstance.close()">{{ 'general.Ok' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">
                        {{ 'general.Cancel' | translate }}
                    </button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash, MomentService) {
        this.lodash = lodash;
        this.MomentService = MomentService;
    }

    $onInit () {
        this.releaseNotes = this.releaseNotes.map(note => {
            return this.lodash.merge(note, { releaseDate: this.MomentService.formatTimeStamp(note.releasedAt, 'DD.MM.YYYY') });
        });

        this.releaseNotes = this.lodash.groupBy(this.releaseNotes, 'releaseDate');
        this.releaseNotes = this.lodash.reverse(this.releaseNotes);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/releaseNote/index.js